import { Button, Card, CardContent, PageHeader } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { OwnerDataTable as DataTable } from "../../components/owner-data-table.tsx";
import { useOwnerState, useUpdatePrivacy } from "../../features/backoffice/queries.ts";

export const Route = createFileRoute("/_app/settings/privacy")({ component: PrivacyScreen });

function PrivacyScreen() {
  const { data } = useOwnerState();
  const update = useUpdatePrivacy();
  const privacy = data?.privacy;
  return (
    <div className="space-y-6">
      <PageHeader
        title="Privacy settings"
        subtitle="Consent policy, contact reveal policy, and data deletion requests. No unsafe PII display."
      />
      {privacy ? (
        <>
          <Card>
            <CardContent className="space-y-4 p-5">
              <p>
                <strong>Consent policy version:</strong> {privacy.consentPolicyVersion}
              </p>
              <p>
                <strong>Contact reveal:</strong> {privacy.contactRevealPolicy}
              </p>
              <Button
                onClick={() =>
                  update.mutate({
                    contactRevealPolicy: "Mutual accept only; owner rules can only restrict.",
                  })
                }
              >
                Update copy placeholder
              </Button>
            </CardContent>
          </Card>
          <DataTable
            rows={privacy.deletionRequests}
            getRowKey={(row) => row.id}
            columns={[
              { key: "id", header: "Request", cell: (row) => row.id },
              { key: "state", header: "State", cell: (row) => row.status },
              { key: "created", header: "Created", cell: (row) => row.createdAt },
            ]}
          />
        </>
      ) : null}
    </div>
  );
}
